'use client'

import { useEffect } from 'react'
import { getPendingVotesFromStorage, exportPendingVotes } from '@/lib/utils/vote-persistence'

/**
 * Initialize vote recovery tools in browser console
 */
function showRecoveryInfo() {
  const pending = getPendingVotesFromStorage()
  
  if (pending.length === 0) {
    console.log('✅ No pending votes to recover')
    return pending
  }
  
  console.group('🔧 Vote Recovery Information')
  console.log(`Total pending votes: ${pending.length}`)
  console.table(pending.map(v => ({
    id: v.id,
    voteID: v.voteID,
    company_id: v.company_id,
    score: v.score,
    retryCount: v.retryCount || 0,
    timestamp: new Date(v.timestamp).toLocaleString(),
    lastError: v.lastError || 'None',
  })))
  console.log('\n💡 To export votes for manual recovery, run: window.voteRecovery.exportVotes()')
  console.groupEnd()
  
  return pending
}

export default function VoteRecoveryInit() {
  useEffect(() => {
    // Initialize recovery tools on window object
    if (typeof window !== 'undefined') {
      window.voteRecovery = {
        showRecoveryInfo: showRecoveryInfo,
        showInfo: showRecoveryInfo, // Alias for convenience
        exportPendingVotes: exportPendingVotes,
        exportVotes: exportPendingVotes, // Alias for convenience
        getPending: getPendingVotesFromStorage,
      }
      console.log('🔧 Vote recovery tools available: window.voteRecovery')
      console.log('   Try: window.voteRecovery.showRecoveryInfo()')
    }
  }, [])

  return null
}

